export enum Densities {
  Default = 'default',
  Compact = 'compact',
}
